export const moduleRegistry = [
    {
        id: 'home',
        name: 'Home',
        path: '/dashboard',
        description: 'Home dashboard',
        icon: '🏠',
        requiresAuth: true,
    },
    {
        id: 'account',
        name: 'My Account',
        path: '/account',
        description: 'Account settings and profile',
        icon: '👤',
        requiresAuth: true,
    },
    {
        id: 'customers',
        name: 'Customers',
        path: '/customers',
        description: 'Customer database and management',
        icon: '👥',
        requiresAuth: true,
    },
    {
        id: 'projects',
        name: 'Projects',
        path: '/projects',
        description: 'Manage field service projects',
        icon: '🔧',
        requiresAuth: true,
    },
    {
        id: 'installers',
        name: 'Team',
        path: '/installers',
        description: 'Manage field team members',
        icon: '👷',
        requiresAuth: true,
    },
    {
        id: 'my-jobs',
        name: 'My Work',
        path: '/my-jobs',
        description: 'Technician job board',
        icon: '📋',
        requiresAuth: true,
    },
    {
        id: 'estimates',
        name: 'Estimates',
        path: '/estimates',
        description: 'Create and manage project estimates',
        icon: '📝',
        requiresAuth: true,
    },
    {
        id: 'suppliers',
        name: 'Suppliers',
        path: '/suppliers',
        description: 'Manage suppliers and vendor contacts',
        icon: '🏭',
        requiresAuth: true,
    },
];
export function getModuleById(id) {
    return moduleRegistry.find((m) => m.id === id);
}
export function getAuthenticatedModules() {
    return moduleRegistry.filter((m) => m.requiresAuth);
}
export function getPublicModules() {
    return moduleRegistry.filter((m) => !m.requiresAuth);
}
//# sourceMappingURL=moduleRegistry.js.map